<template>
    <div>
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner"></div>
        </div>
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço residencial'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Endereço'" :SubSessao="'Endereço residencial'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">CEP*</label>
                            <input class="field" type="text" id="cep" placeholder="" v-model="localPF.Cep"
                                @change="salvarAlteracoesLocalmente(); validarCep(localPF)">
                            <p v-if="camposObrigatorios.erroEnderecoCep" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="custom-link" style="width: 8%; margin-top: 35px;">
                            <a target="_blank" href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não
                                sei o CEP</a>
                        </div>
                        <div class="label__field" style="width: 47%">
                            <label class="label" for="nome">Endereço*</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoLogradouro" id="endereco"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.Logradouro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoLogradouro" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">Número*</label>
                            <input class="field" type="text" id="numero" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.LogradouroNumero" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoNumero" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 47%">
                            <label class="label" for="nome">Complemento</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.LogradouroComplemento" id="complemento" placeholder="">
                        </div>
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="nome">Bairro*</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoLogradouro" v-model="localPF.Bairro"
                                @change="salvarAlteracoesLocalmente" id="bairro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoBairro" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">Cidade*</label>
                            <input class="field" type="text" :disabled="isDisabledEndereco" v-model="localPF.Cidade"
                                @change="salvarAlteracoesLocalmente" id="cidade" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoCidade" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">UF*</label>
                            <select id="uf" @change="salvarAlteracoesLocalmente" v-model="localPF.Uf" class="field">
                                <option value="null">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoUf" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">País*</label>
                            <select id="pais" @change="salvarAlteracoesLocalmente" class="field" v-model="localPF.LogradouroPais"
                                :disabled="isDisabledEndereco">
                                <option value="">Selecione</option>
                                <option v-for="item in listaPaises" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoPais" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Esse endereço é o mesmo de correspondência?*</label>
                            <div class="radio">
                                <input type="radio" id="1" value="1" name="EnderecoCorrespondencia" class="field__radio"
                                    v-model="localPF.EnderecoCorrespondencia"
                                    @change="salvarAlteracoesLocalmenteLimpandoEnderecoCorrespondencia" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="2" value="2" name="EnderecoCorrespondencia" class="field__radio"
                                    v-model="localPF.EnderecoCorrespondencia" @change="salvarAlteracoesLocalmente" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario" v-if="localPF.EnderecoCorrespondencia == 2">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço correspondência'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Endereço'" :SubSessao="'Endereço correspondência'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">CEP*</label>
                            <input class="field" type="text" id="cep" placeholder="" v-model="localPF.CepOutro"
                                @change="salvarAlteracoesLocalmente(); validarCepOutro(localPF)">
                            <p v-if="camposObrigatorios.erroEnderecoOutroCep" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="custom-link" style="width: 8%; margin-top: 35px;">
                            <a target="_blank" href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não
                                sei o CEP</a>
                        </div>
                        <div class="label__field" style="width: 47%">
                            <label class="label" for="nome">Endereço*</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoOutroLogradouro" id="endereco"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.LogradouroOutro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroLogradouro" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">Número*</label>
                            <input class="field" type="text" id="numero" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.LogradouroNumeroOutro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroNumero" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 47%">
                            <label class="label" for="nome">Complemento</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.LogradouroComplementoOutro" id="complemento" placeholder="">
                        </div>
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="nome">Bairro*</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoOutroLogradouro"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.BairroOutro" id="bairro"
                                placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroBairro" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">Cidade*</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoOutro"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.CidadeOutro" id="cidade"
                                placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroCidade" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">UF*</label>
                            <select id="uf" @change="salvarAlteracoesLocalmente" v-model="localPF.UfOutro" class="field"
                                :disabled="isDisabledEnderecoOutro">
                                <option value="null">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoOutroUf" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">País*</label>
                            <select id="PaisOutro" @change="salvarAlteracoesLocalmente" class="field"
                                v-model="localPF.PaisOutro" :disabled="isDisabledEnderecoOutro">
                                <option value="">Selecione</option>
                                <option v-for="item in listaPaises" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoOutroPais" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço comercial'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Endereço'" :SubSessao="'Endereço comercial'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">CEP*</label>
                            <input class="field" type="text" id="cep" placeholder=""
                                @change="salvarAlteracoesLocalmente(); validarCepComercial(localPF)"
                                v-model="localPF.EnderecoComercialCep">
                            <p v-if="camposObrigatorios.erroEnderecoComercialCep" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="custom-link" style="width: 8%; margin-top: 35px;">
                            <a target="_blank" href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não
                                sei o CEP</a>
                        </div>
                        <div class="label__field" style="width: 47%">
                            <label class="label" for="nome">Endereço*</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoComercialLogradouro"
                                id="endereco" @change="salvarAlteracoesLocalmente" v-model="localPF.EnderecoComercial"
                                placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoComercialLogradouro" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">Número*</label>
                            <input class="field" type="text" id="numero" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.EnderecoComercialNumero" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoComercialNumero" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 47%">
                            <label class="label" for="nome">Complemento</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.EnderecoComercialComplemento" id="complemento" placeholder="">
                        </div>
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="nome">Bairro*</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoComercialLogradouro"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.EnderecoComercialBairro"
                                id="bairro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoComercialBairro" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">Cidade*</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoComercial"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.EnderecoComercialCidade"
                                id="cidade" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoComercialCidade" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">UF*</label>
                            <select id="uf" :disabled="isDisabledEnderecoComercial" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.EnderecoComercialEstado" class="field">
                                <option value="null">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoComercialUf" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">País*</label>
                            <select id="PaisOutro" @change="salvarAlteracoesLocalmente" class="field"
                                v-model="localPF.EnderecoComercialPais" :disabled="isDisabledEnderecoComercial">
                                <option value="">Selecione</option>
                                <option v-for="item in listaPaises" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoComercialPais" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'
import { validarCampoCep, ufs } from '@/utils/formUtils';

export default {
    name: 'CadastroPF_Endereco',
    props: ['informacoesBasicas', 'Edicao'],
    components: { LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            infoBasicas: 'GET_PF_INFO_BASICAS',
            listaPaises: 'GET_LISTA_PAISES',
        }),
        ufs() {
            return ufs;
        },
    },
    data() {
        return {
            camposObrigatorios: {
                erroEnderecoCep: false,
                erroEnderecoLogradouro: false,
                erroEnderecoNumero: false,
                erroEnderecoBairro: false,
                erroEnderecoCidade: false,
                erroEnderecoUf: false,
                erroEnderecoPais: false,
                erroEnderecoOutroCep: false,
                erroEnderecoOutroLogradouro: false,
                erroEnderecoOutroNumero: false,
                erroEnderecoOutroBairro: false,
                erroEnderecoOutroCidade: false,
                erroEnderecoOutroUf: false,
                erroEnderecoOutroPais: false,
                erroEnderecoComercialCep: false,
                erroEnderecoComercialLogradouro: false,
                erroEnderecoComercialNumero: false,
                erroEnderecoComercialBairro: false,
                erroEnderecoComercialCidade: false,
                erroEnderecoComercialUf: false,
                erroEnderecoComercialPais: false,
            },
            isDisabledEndereco: true,
            isDisabledEnderecoComercial: true,
            isDisabledEnderecoOutro: true,
            isDisabledEnderecoLogradouro: true,
            isDisabledEnderecoOutroLogradouro: true,
            isDisabledEnderecoComercialLogradouro: true,
            localPF: this.informacoesBasicas,
            permitirAvancar: false,
            isLoading: false,
        }
    },
    created() {
        this.validarCep(this.localPF, true);
        if (this.localPF.EnderecoCorrespondencia == 2) this.validarCepOutro(this.localPF, true);
        this.validarCepComercial(this.localPF, true);
    },
    mounted() {
        if (this.localPF != null) {
            this.localPF.EnderecoCorrespondencia = this.informacoesBasicas.CepOutro != '' && this.localPF.CepOutro != null ? 2 : 1;
        }
        this.validarFormulario();
    },
    methods: {
        salvarAlteracoesLocalmenteLimpandoEnderecoCorrespondencia() {
            this.localPF.LogradouroOutro = null;
            this.localPF.BairroOutro = null;
            this.localPF.CidadeOutro = null;
            this.localPF.UfOutro = null;
            this.localPF.PaisOutro = null;
            this.localPF.CepOutro = null;
            this.salvarAlteracoesLocalmente();
        },
        proximaEtapa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.$store.commit('SET_ETAPA_CADASTRO', 5);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_PF_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PF_SALVAR_INFO_ENDERECO', this.localPF);
            this.validarFormulario(false);
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroEnderecoCep: false,
                erroEnderecoLogradouro: false,
                erroEnderecoNumero: false,
                erroEnderecoBairro: false,
                erroEnderecoCidade: false,
                erroEnderecoUf: false,
                erroEnderecoPais: false,
                erroEnderecoOutroCep: false,
                erroEnderecoOutroLogradouro: false,
                erroEnderecoOutroNumero: false,
                erroEnderecoOutroBairro: false,
                erroEnderecoOutroCidade: false,
                erroEnderecoOutroUf: false,
                erroEnderecoOutroPais: false,
                erroEnderecoComercialCep: false,
                erroEnderecoComercialLogradouro: false,
                erroEnderecoComercialNumero: false,
                erroEnderecoComercialBairro: false,
                erroEnderecoComercialCidade: false,
                erroEnderecoComercialUf: false,
                erroEnderecoComercialPais: false,
            };
            if (!this.localPF.Cep) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoCep = true;
                    nomeDoCampo = 'CEP do Endereço Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.Logradouro) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoLogradouro = true;
                    nomeDoCampo = 'Logradouro do Endereço Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.LogradouroNumero) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoNumero = true;
                    nomeDoCampo = 'Número do Endereço Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.Bairro) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoBairro = true;
                    nomeDoCampo = 'Bairro do Endereço Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.Cidade) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoCidade = true;
                    nomeDoCampo = 'Cidade do Endereço Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.Uf) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoUf = true;
                    nomeDoCampo = 'Uf do Endereço Principal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.LogradouroPais) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoPais = true;
                    nomeDoCampo = 'País do Endereço Principal';
                }
                this.permitirAvancar = false;
            }

            if (!this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroCep = true;
                    nomeDoCampo = 'CEP do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.LogradouroOutro && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroLogradouro = true;
                    nomeDoCampo = 'Logradouro do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.LogradouroNumeroOutro && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroNumero = true;
                    nomeDoCampo = 'Número do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.BairroOutro && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroBairro = true;
                    nomeDoCampo = 'Bairro do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.CidadeOutro && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroCidade = true;
                    nomeDoCampo = 'Cidade do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.UfOutro && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroUf = true;
                    nomeDoCampo = 'Uf do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.PaisOutro && (this.localPF.CepOutro && this.localPF.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroPais = true;
                    nomeDoCampo = 'País do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }

            if (!this.localPF.EnderecoComercialCep) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoComercialCep = true;
                    nomeDoCampo = 'CEP do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.EnderecoComercial) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoComercialLogradouro = true;
                    nomeDoCampo = 'Logradouro do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.EnderecoComercialNumero) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoComercialNumero = true;
                    nomeDoCampo = 'Número do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.EnderecoComercialBairro) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoComercialBairro = true;
                    nomeDoCampo = 'Bairro do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.EnderecoComercialCidade) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoComercialCidade = true;
                    nomeDoCampo = 'Cidade do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.EnderecoComercialEstado) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoComercialUf = true;
                    nomeDoCampo = 'Uf do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.EnderecoComercialPais) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoComercialPais = true;
                    nomeDoCampo = 'País do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (nomeDoCampo != '' && submeter) {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` não foi informado, preencha a informação para avançar.`,
                });
            }
        },
        async validarCep(objDados, somenteValidar = false) {
            this.isLoading = true;
            try {
                if (objDados.Cep) {
                    console.log(objDados);
                    var result = await validarCampoCep(objDados, { somenteValidar: somenteValidar });
                    if (result) {
                        this.localPF.LogradouroPais = 'BRA';
                        this.isDisabledEndereco = true;
                        this.isDisabledEnderecoLogradouro = true;
                        if (objDados.Logradouro == '') {
                            this.isDisabledEnderecoLogradouro = false;
                        }
                    } else {
                        this.isDisabledEndereco = false;
                        this.isDisabledEnderecoLogradouro = false;
                    }
                }
            } finally {
                this.isLoading = false;
            }
        },
        async validarCepOutro(objDados, somenteValidar = false) {
            this.isLoading = true;
            try {
                if (objDados.CepOutro) {
                    var result = await validarCampoCep(objDados, { somenteValidar: somenteValidar, tipoEndereco: "Outro" });
                    if (result) {
                        this.isDisabledEnderecoOutro = true;
                        this.isDisabledEnderecoOutroLogradouro = true;
                        if (objDados.LogradouroOutro == '')
                            this.isDisabledEnderecoOutroLogradouro = false;
                    } else {
                        this.isDisabledEnderecoOutro = false;
                        this.isDisabledEnderecoOutroLogradouro = false;
                    }
                }
            } finally {
                this.isLoading = false;
            }
        },
        async validarCepComercial(objDados, somenteValidar = false) {
            this.isLoading = true;
            try {
                if (objDados.EnderecoComercialCep) {
                    var result = await validarCampoCep(objDados, { somenteValidar: somenteValidar, tipoEndereco: "EnderecoComercial" });
                    if (result) {
                        this.isDisabledEnderecoComercial = true;
                        this.isDisabledEnderecoComercialLogradouro = true;
                        if (objDados.EnderecoComercial == '')
                            this.isDisabledEnderecoComercialLogradouro = false;
                    } else {
                        this.isDisabledEnderecoComercial = false;
                        this.isDisabledEnderecoComercialLogradouro = false;
                    }
                }
            } finally {
                this.isLoading = false;
            }
        },
    }
}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.formulario {
    width: 100%;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
}

.categoriaAgrupamentoFormulario {
    width: 13%;
    margin-right: 15px;
    font-family: 'Inter', sans-serif;

    span {
        font-weight: 400 !important;
        font-size: 13px;
        color: #667085;
    }
}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }

    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .fieldInRadio {
            border-radius: 8px;
            border: 1px solid #D0D5DD;
            padding: 10px 14px;
            background-color: #F9FAFB;
            width: 55%;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }

    label {
        font-family: 'Inter', sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #344054;
        display: block;
        margin-bottom: 8px;
    }
}

.title {

    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;
    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #000;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}
</style>